import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=dfe3e760&scoped=true&"
import script from "./productList.vue?vue&type=script&lang=babel&"
export * from "./productList.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe3e760",
  null
  
)

export default component.exports